<script lang="ts" setup>
  import { Flag, Typo, TypoVariant } from '@travelata-libs/ui-kit';
  import { toRef } from 'vue';
  import { type SearchCriteriaHistory } from '@/entities/searchCriteria';
  import { useHistoryCard } from '../model/useHistoryCard';

  interface MobileHistoryCardProps {
    historySearch: SearchCriteriaHistory;
  }

  const props = defineProps<MobileHistoryCardProps>();

  const { title, dateText, touristsText, flagName, onClick } = useHistoryCard({
    historySearch: toRef(props, 'historySearch'),
  });
</script>

<template>
  <div
    class="mobile-history-card"
    data-testid="mobile-history-card"
    @click="onClick"
  >
    <div class="mobile-history-card__flag-container">
      <Flag
        class="mobile-history-card__flag"
        :name="flagName"
      />
    </div>
    <div class="mobile-history-card__info">
      <Typo
        class="mobile-history-card__title"
        :variant="TypoVariant.Heading6"
        tag="span"
      >
        {{ title }}
      </Typo>
      <div class="mobile-history-card__details">
        <Typo
          class="mobile-history-card__date"
          :variant="TypoVariant.BodyLRegular"
          tag="span"
        >
          {{ dateText }}
        </Typo>
        <Typo
          class="mobile-history-card__tourists"
          :variant="TypoVariant.BodyLRegular"
          tag="span"
        >
          {{ touristsText }}
        </Typo>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .mobile-history-card {
    align-items: flex-start;
    background: var(--color-bg-primary);
    border: 1px solid var(--color-neutral-20);
    border-radius: var(--rounding-xl);
    box-shadow: var(--shadow-xxs);
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-s);
    padding: var(--spacing-m);
    width: 100%;

    &__flag-container {
      border: 1px solid var(--color-neutral-0);
      border-radius: 100%;
      box-shadow: var(--shadow-s);
      box-sizing: content-box;
      display: flex;
      flex: 0 0 auto;
      height: 28px;
      width: 28px;
    }

    &__flag {
      border-radius: 100%;
      display: block;
      height: 28px;
      width: 28px;
    }

    &__info {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xxs);
      min-width: 0;
    }

    &__title {
      color: var(--color-text-primary);
    }

    &__details {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xxxs);
    }

    &__date,
    &__tourists {
      color: var(--color-text-secondary);
    }
  }
</style>
